import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {CustomerComponent} from './customer/customer.component';
import {MatToolbarModule} from "@angular/material/toolbar";
import {PermissionDeniedComponent} from './permission-denied/permission-denied.component';
import {provideKeycloak, includeBearerTokenInterceptor, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG} from "keycloak-angular";
import {AppRoutingModule} from "./app.routing.module";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MatButtonModule} from "@angular/material/button";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from "@angular/material/menu";
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from "@angular/common/http";
import {MatTableModule} from "@angular/material/table";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatCardModule} from "@angular/material/card";
import {ContractComponent} from './contract/contract.component';
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatDialogModule} from "@angular/material/dialog";
import {ContractEditDialogComponent} from "./contract/dialog/contract.edit.dialog.component";
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {environment} from "../environments/environment";
import { ClipboardModule } from '@angular/cdk/clipboard'

@NgModule({ declarations: [
        AppComponent,
        CustomerComponent,
        PermissionDeniedComponent,
        ContractComponent,
        ContractEditDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatGridListModule,
        MatToolbarModule,
        MatListModule,
        MatMenuModule,
        MatTableModule,
        MatSidenavModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatIconModule,
        MatCardModule,
        MatPaginatorModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        ClipboardModule], providers: [
        provideKeycloak({
            config: {
                url: environment.keycloakURL,
                realm: 'tremaze-company',
                clientId: 'ksvs-cc',
            },
            initOptions: {
                onLoad: 'check-sso',
                redirectUri: environment.keycloakRedirectURL,
                checkLoginIframe: false
            }
        }),
        provideHttpClient(
            withInterceptors([includeBearerTokenInterceptor]),
            withInterceptorsFromDi()
        ),
        {
            provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [{
                urlPattern: new RegExp(environment.apiURL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/.*'),
            }]
        }
    ] })
export class AppModule {

}
